import {FC} from "react";
import {CaptureVariableIcon} from "./CaptureVariableIcon";

export const CollectVariablesNodeIcon: FC<
  React.SVGProps<SVGSVGElement>
> = () => (
  <CaptureVariableIcon
    className={"text-white [&_svg]:size-3.5"}
    strokeWidth={2.5}
  />
);

export const SpeakNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12.0015L1.26667 8.20147C0.664753 6.99799 0.510745 5.61959 0.832203 4.31294C1.15366 3.0063 1.9296 1.85668 3.02117 1.06983C4.11274 0.282973 5.44869 -0.0897647 6.78995 0.0183175C8.13121 0.1264 9.39024 0.708247 10.3417 1.65974C11.2932 2.61122 11.8751 3.87025 11.9832 5.21152C12.0912 6.55278 11.7185 7.88873 10.9316 8.9803C10.1448 10.0719 8.99517 10.8478 7.68853 11.1693C6.38188 11.4907 5.00348 11.3367 3.8 10.7348L0 12.0015Z"
      fill={fill}
    />
  </svg>
);

export const GlobalNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#4E5B6F",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.14667 0.332031H6.85333C6.49971 0.332031 6.16057 0.472507 5.91053 0.722556C5.66048 0.972604 5.52 1.31174 5.52 1.66536V1.78536C5.51976 2.01918 5.45804 2.24882 5.34103 2.45126C5.22401 2.65369 5.05583 2.82179 4.85333 2.9387L4.56667 3.10536C4.36398 3.22239 4.13405 3.284 3.9 3.284C3.66595 3.284 3.43603 3.22239 3.23333 3.10536L3.13333 3.05203C2.82738 2.87554 2.46389 2.82766 2.12267 2.9189C1.78145 3.01015 1.49037 3.23306 1.31333 3.5387L1.16667 3.79203C0.990176 4.09799 0.942297 4.46147 1.03354 4.8027C1.12478 5.14392 1.34769 5.435 1.65333 5.61203L1.75333 5.6787C1.95485 5.79504 2.12241 5.96209 2.23937 6.16325C2.35632 6.36441 2.4186 6.59268 2.42 6.82537V7.16537C2.42093 7.40031 2.35977 7.63133 2.2427 7.83504C2.12563 8.03874 1.95681 8.20789 1.75333 8.32537L1.65333 8.38536C1.34769 8.5624 1.12478 8.85348 1.03354 9.1947C0.942297 9.53592 0.990176 9.89941 1.16667 10.2054L1.31333 10.4587C1.49037 10.7643 1.78145 10.9873 2.12267 11.0785C2.46389 11.1697 2.82738 11.1219 3.13333 10.9454L3.23333 10.892C3.43603 10.775 3.66595 10.7134 3.9 10.7134C4.13405 10.7134 4.36398 10.775 4.56667 10.892L4.85333 11.0587C5.05583 11.1756 5.22401 11.3437 5.34103 11.5461C5.45804 11.7486 5.51976 11.9782 5.52 12.212V12.332C5.52 12.6857 5.66048 13.0248 5.91053 13.2748C6.16057 13.5249 6.49971 13.6654 6.85333 13.6654H7.14667C7.50029 13.6654 7.83943 13.5249 8.08948 13.2748C8.33953 13.0248 8.48 12.6857 8.48 12.332V12.212C8.48024 11.9782 8.54196 11.7486 8.65898 11.5461C8.77599 11.3437 8.94418 11.1756 9.14667 11.0587L9.43333 10.892C9.63603 10.775 9.86595 10.7134 10.1 10.7134C10.3341 10.7134 10.564 10.775 10.7667 10.892L10.8667 10.9454C11.1726 11.1219 11.5361 11.1697 11.8773 11.0785C12.2186 10.9873 12.5096 10.7643 12.6867 10.4587L12.8333 10.1987C13.0098 9.89274 13.0577 9.52926 12.9665 9.18803C12.8752 8.84681 12.6523 8.55573 12.3467 8.3787L12.2467 8.32537C12.0432 8.20789 11.8744 8.03874 11.7573 7.83504C11.6402 7.63133 11.5791 7.40031 11.58 7.16537V6.83203C11.5791 6.59708 11.6402 6.36606 11.7573 6.16236C11.8744 5.95866 12.0432 5.7895 12.2467 5.67203L12.3467 5.61203C12.6523 5.435 12.8752 5.14392 12.9665 4.8027C13.0577 4.46147 13.0098 4.09799 12.8333 3.79203L12.6867 3.5387C12.5096 3.23306 12.2186 3.01015 11.8773 2.9189C11.5361 2.82766 11.1726 2.87554 10.8667 3.05203L10.7667 3.10536C10.564 3.22239 10.3341 3.284 10.1 3.284C9.86595 3.284 9.63603 3.22239 9.43333 3.10536L9.14667 2.9387C8.94418 2.82179 8.77599 2.65369 8.65898 2.45126C8.54196 2.24882 8.48024 2.01918 8.48 1.78536V1.66536C8.48 1.31174 8.33953 0.972604 8.08948 0.722556C7.83943 0.472507 7.50029 0.332031 7.14667 0.332031Z"
      fill={fill}
    />
    <path
      d="M7 8.9987C8.10457 8.9987 9 8.10327 9 6.9987C9 5.89413 8.10457 4.9987 7 4.9987C5.89543 4.9987 5 5.89413 5 6.9987C5 8.10327 5.89543 8.9987 7 8.9987Z"
      fill="#FCFCFD"
    />
  </svg>
);

export const StartNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6669 10.2788V12.2788C13.6677 12.4644 13.6297 12.6482 13.5553 12.8183C13.4809 12.9884 13.3718 13.1412 13.235 13.2667C13.0982 13.3922 12.9367 13.4878 12.7608 13.5472C12.5849 13.6067 12.3985 13.6288 12.2136 13.6121C10.1622 13.3892 8.19161 12.6882 6.46028 11.5654C4.8495 10.5419 3.48384 9.17621 2.46028 7.56543C1.3336 5.82623 0.632443 3.84609 0.413614 1.78543C0.396955 1.60107 0.418864 1.41527 0.477948 1.23985C0.537032 1.06442 0.631995 0.903222 0.756792 0.76651C0.881588 0.629798 1.03348 0.520569 1.20281 0.445777C1.37213 0.370986 1.55517 0.33227 1.74028 0.332096H3.74028C4.06382 0.328912 4.37748 0.443482 4.62279 0.654451C4.8681 0.86542 5.02833 1.15839 5.07361 1.47876C5.15803 2.11881 5.31458 2.74725 5.54028 3.3521C5.62998 3.59071 5.64939 3.85004 5.59622 4.09935C5.54305 4.34866 5.41952 4.5775 5.24028 4.75876L4.39361 5.60543C5.34265 7.27446 6.72458 8.65639 8.39361 9.60543L9.24028 8.75876C9.42154 8.57952 9.65038 8.456 9.89969 8.40283C10.149 8.34966 10.4083 8.36907 10.6469 8.45876C11.2518 8.68446 11.8802 8.84101 12.5203 8.92543C12.8441 8.97112 13.1399 9.13423 13.3513 9.38376C13.5627 9.63329 13.6751 9.95181 13.6669 10.2788Z"
      fill={fill}
    />
  </svg>
);

export const JumpNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1.66797V5.66797M13 5.66797H9M13 5.66797L11 3.86797C9.90076 2.88207 8.47659 2.33614 7 2.33464C5.4087 2.33464 3.88258 2.96678 2.75736 4.09199C1.63214 5.21721 1 6.74334 1 8.33464M7.66667 8.33464C7.66667 8.70283 7.36819 9.0013 7 9.0013C6.63181 9.0013 6.33333 8.70283 6.33333 8.33464C6.33333 7.96645 6.63181 7.66797 7 7.66797C7.36819 7.66797 7.66667 7.96645 7.66667 8.33464Z"
      stroke={fill}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EndNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.12028 9.8721C8.79685 10.5493 9.56149 11.1323 10.3936 11.6054L11.2403 10.7588C11.4215 10.5795 11.6504 10.456 11.8997 10.4028C12.149 10.3497 12.4083 10.3691 12.6469 10.4588C13.2518 10.6845 13.8802 10.841 14.5203 10.9254C14.8407 10.9707 15.1336 11.1309 15.3446 11.3763C15.5556 11.6216 15.6701 11.9352 15.6669 12.2588V14.2588C15.6677 14.4444 15.6297 14.6282 15.5553 14.7983C15.4809 14.9684 15.3718 15.1212 15.235 15.2467C15.0982 15.3722 14.9367 15.4678 14.7608 15.5272C14.5849 15.5867 14.3985 15.6088 14.2136 15.5921C12.1622 15.3692 10.1916 14.6682 8.46028 13.5454C7.65713 13.0355 6.91263 12.4385 6.24028 11.7654M4.46028 9.53876C3.33752 7.80743 2.63652 5.83687 2.41361 3.78543C2.39695 3.60107 2.41886 3.41527 2.47795 3.23985C2.53703 3.06442 2.63199 2.90322 2.75679 2.76651C2.88159 2.6298 3.03348 2.52057 3.20281 2.44578C3.37213 2.37099 3.55517 2.33227 3.74028 2.3321H5.74028C6.06382 2.32891 6.37748 2.44348 6.62279 2.65445C6.8681 2.86542 7.02833 3.15839 7.07361 3.47876C7.15803 4.11881 7.31458 4.74725 7.54028 5.3521C7.62998 5.59071 7.64939 5.85004 7.59622 6.09935C7.54305 6.34866 7.41952 6.5775 7.24028 6.75876L6.39361 7.60543"
      fill={fill}
    />
    <path
      d="M8.12028 9.8721C8.79685 10.5493 9.56149 11.1323 10.3936 11.6054L11.2403 10.7588C11.4215 10.5795 11.6504 10.456 11.8997 10.4028C12.149 10.3497 12.4083 10.3691 12.6469 10.4588C13.2518 10.6845 13.8802 10.841 14.5203 10.9254C14.8407 10.9707 15.1336 11.1309 15.3446 11.3763C15.5556 11.6216 15.6701 11.9352 15.6669 12.2588V14.2588C15.6677 14.4444 15.6297 14.6282 15.5553 14.7983C15.4809 14.9684 15.3718 15.1212 15.235 15.2467C15.0982 15.3722 14.9367 15.4678 14.7608 15.5272C14.5849 15.5867 14.3985 15.6088 14.2136 15.5921C12.1622 15.3692 10.1916 14.6682 8.46028 13.5454C7.65713 13.0355 6.91263 12.4385 6.24028 11.7654L4.46028 9.53876C3.33752 7.80743 2.63652 5.83687 2.41361 3.78543C2.39695 3.60107 2.41886 3.41527 2.47795 3.23985C2.53703 3.06442 2.63199 2.90322 2.75679 2.76651C2.88159 2.6298 3.03348 2.52057 3.20281 2.44578C3.37213 2.37099 3.55517 2.33227 3.74028 2.3321H5.74028C6.06382 2.32891 6.37748 2.44348 6.62279 2.65445C6.8681 2.86542 7.02833 3.15839 7.07361 3.47876C7.15803 4.11881 7.31458 4.74725 7.54028 5.3521C7.62998 5.59071 7.64939 5.85004 7.59622 6.09935C7.54305 6.34866 7.41952 6.5775 7.24028 6.75876L6.39361 7.60543L8.12028 9.8721Z"
      fill={fill}
    />
    <path
      d="M14.96 1.625C15.3506 1.23435 15.9837 1.23512 16.374 1.625C16.7644 2.01554 16.7645 2.64858 16.374 3.03906L3.04102 16.3721C2.65054 16.7625 2.01749 16.7625 1.62695 16.3721C1.23707 15.9818 1.2363 15.3487 1.62695 14.958L14.96 1.625Z"
      fill={fill}
      stroke="#EA4A4B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActionNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66667 0.332031L0 8.33203H6L5.33333 13.6654L12 5.66536H6L6.66667 0.332031Z"
      fill={fill}
    />
  </svg>
);

export const TransferNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66602 3.66667L4.33268 1V6.33333L1.66602 3.66667ZM1.66602 3.66667H12.3327M12.3327 10.3333L9.66602 13V7.66667L12.3327 10.3333ZM12.3327 10.3333H1.66602"
      stroke={fill}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookingNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6673 1.33203V3.9987M5.33398 1.33203V3.9987"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 2.66406H3.33333C2.59695 2.66406 2 3.26102 2 3.9974V13.3307C2 14.0671 2.59695 14.6641 3.33333 14.6641H12.6667C13.403 14.6641 14 14.0671 14 13.3307V3.9974C14 3.26102 13.403 2.66406 12.6667 2.66406Z"
      fill={fill}
    />
    <path
      d="M2 6.66406H14"
      stroke="#F4762D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaptureVariableNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g transform="translate(6 6) scale(0.5)">
      <path
        d="M12 5v14"
        stroke={fill}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m19 12-7 7-7-7"
        stroke={fill}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const EntryNodeIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 12,
  height = 12,
  fill = "#FCFCFD",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14Z"
      fill={fill}
    />
    <path
      d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
      fill={fill}
    />
    <path
      d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
      fill={fill}
    />
    <path
      d="M8 10V8M4 6C4 6 4 6.31304 4 6.66667C4 7.02029 4.14048 7.35943 4.39052 7.60948C4.64057 7.85952 4.97971 8 5.33333 8H10.6667C11.0203 8 11.3594 7.85952 11.6095 7.60948C11.8595 7.35943 12 7.02029 12 6.66667V6"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default {
  SpeakNodeIcon,
  GlobalNodeIcon,
  StartNodeIcon,
  JumpNodeIcon,
  EndNodeIcon,
  ActionNodeIcon,
  TransferNodeIcon,
  BookingNodeIcon,
  CollectVariablesNodeIcon,
  EntryNodeIcon,
};
